<template>
  <div class="menu__container" :class="{ 'menu__container--open': display }">
    <MobileMenuIcons v-model="display" />
    <nav class="menu">
      <ul class="menu__items">
        <li v-for="(value, key) in elements" :key="key" class="menu__item">
          <SubMenu v-if="Array.isArray(value)" :name="key" :elements="value" />
          <a v-else class="menu__link" :href="value">
            {{ key }}
          </a>
        </li>
      </ul>
      <Contact />
      <Moles :count="1" background="transparent" align="right" class="menu__moles" :scale="2.25" reversed />
    </nav>
  </div>
</template>

<script>
import { ref, toRefs, watch } from '@vue/composition-api';
import { Link } from '@inertiajs/inertia-vue';
import { onMinWidth } from '@/lego/utils/window/screen';
import Contact from '@/lego/partials/Contact.vue';
import SubMenu from '@/lego/components/menus/SubMenu.vue';
import MobileMenuIcons from '@/lego/components/menus/MobileMenuIcons.vue';
import Moles from '@/lego/components/layout/Moles.vue';

export default {
  components: {
    Link,
    Contact,
    SubMenu,
    MobileMenuIcons,
    Moles,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    elements: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);
    const display = ref(value.value);

    watch(value, val => (display.value = val));

    watch(display, val => {
      emit('input', val);
    });

    onMinWidth(996, function(event) {
      display.value = false;
    });

    return {
      display,
    };
  },
};
</script>

<style lang="postcss" scoped>
.menu {
  @apply fixed inset-0 bottom-0 z-50 squish-sm lg:p-0 hidden overflow-y-auto lg:overflow-y-visible lg:flex lg:flex-row lg:gap-xxs lg:items-center bg-brand-primary-light lg:bg-transparent lg:static top-[5.75rem] h-[calc(100vh-5.75rem)] lg:h-auto;

  .menu__container--open & {
    @apply flex flex-col justify-between;
  }

  &__items {
    @apply flex flex-col style-subtitle-sm-bold lg:style-overline-bold gap-xs lg:gap-0 lg:flex-row lg:items-center justify-between lg:min-h-full lg:flex lg:px-[0.375rem] lg:py-0;
  }
  &__item {
    @apply hover:cursor-pointer;
  }
  &__link {
    @apply uppercase flex items-center justify-between gap-nano lg:px-xxxs lg:py-xs;

    .menu__item:hover & {
      @apply text-brand-primary-darkest;
    }
  }

  &__moles {
    @apply lg:hidden -left-[14rem] -bottom-sm sm:bottom-0 sm:-left-huge scale-90 sm:scale-100 opacity-60 -z-[1];
  }
}
</style>
